export const getFirstAllowedRoute = (menuItems, permissionApi) => {
  const { hasAny } = permissionApi;

  for (const menu of menuItems) {
    if (menu?.route && hasAny(menu?.permissions)) {
      return menu?.route;
    }

    if (menu?.submenus?.length) {
      for (const sub of menu?.submenus) {
        if (hasAny(sub?.permissions)) {
          return sub?.route;
        }
      }
    }
  }

  return "/unauthorized";
};
